<template>
  <div class="Bottle">  
    <div class="Bottle__test">
      <img :src="require('@/commons/img/test.png')"/>
    </div>  
  </div>
</template>

<script>


export default {
  name: 'Bottle',
}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Bottle
    position absolute
    width 100vw
    height 100%
    color white
    background #81849f
    display flex 
    align-items center
    justify-content center

    &__test 
      max-width 480px

</style>